<template>
  <div
    v-if="flowsErrorMessage"
    class="h-full flex items-center justify-center"
  >
    <div>
      <p
        class="text-destructive-emphasis text-base"
      >
        {{ flowsErrorMessage }}
      </p>

      <button
        v-if="isErrorReloadButtonShown"
        type="button"
        class="bg-transparent w-full flex items-center justify-center h-8 p-2 border-[0.5px] border-solid border-default hover:border-brand-600 focus:border-brand-600 focus:bg-brand-50 rounded hover:bg-brand-50"
        @click="reloadFlows"
      >
        Reload Flows
      </button>
    </div>
  </div>

  <div
    v-if="flowsUrl"
    class="flex flex-col h-full w-full"
  >
    <GlobalLoading :is-loading="isLoadingIframe" />

    <header
      v-if="!isLoadingIframe"
      class="flex items-center justify-between bg-default px-6 py-4"
    >
      <h1 class="text-2xl font-medium text-emphasis m-0">
        Flows
      </h1>
      <div class="flex items-center gap-4">
        <a
          :href="FLOWS_HELP_URL"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center gap-1 rounded border border-solid border-default bg-white
            px-3 py-1.5 text-sm font-semibold text-emphasis"
        >
          Help with Flows
          <Icon
            type="link-external"
            class="h-3.5 w-3.5"
          />
        </a>
      </div>
    </header>

    <iframe
      class="flex-1 min-h-0 w-full"
      :class="{ 'hidden': isLoadingIframe }"
      :src="flowsUrl"
      sandbox="allow-scripts allow-same-origin allow-storage-access-by-user-activation allow-modals allow-popups allow-forms"
      @load="onIframeLoad"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Api from '@/lib/api-wrapper';
import RequestUtils from '@/components/util/RequestUtils';
import Icon from '@/components/ui/Icon.vue';
import GlobalLoading from '@/components/ui/GlobalLoading.vue';
import { isSharedBuilder } from '@/lib/plan-helper';

const FLOWS_HELP_URL = 'https://docs.knack.com/v5/docs/flows-getting-started';

export default {
  name: 'FlowsList',
  components: { GlobalLoading, Icon },
  mixins: [
    RequestUtils,
  ],
  data() {
    return {
      flowsUrl: null,
      flowsErrorMessage: null,
      isErrorReloadButtonShown: false,
      isLoadingIframe: true,
      FLOWS_HELP_URL,
    };
  },
  created() {
    if (isSharedBuilder()) {
      this.$router.push('/');
      return;
    }

    this.loadFlows();
  },
  computed: {
    ...mapGetters([
      'hasFeature',
    ]),
  },
  methods: {
    onIframeLoad() {
      this.isLoadingIframe = false;
    },
    reloadFlows() {
      this.resetFlowsUrl();
      this.loadFlows();
    },
    loadFlows() {
      this.flowsUrl = this.getFlowsUrl();
      if (this.flowsUrl) {
        return;
      }

      this.flowsUrl = null;
      this.flowsErrorMessage = null;

      this.commitRequest({
        request: () => {
          const options = {
            url: '/flows/get-embedded-ui-url',
            method: 'POST',
            encoding: null,
          };
          return Api.axios(options);
        },
        onSuccess: (result) => {
          this.flowsUrl = result.flowsUrl;
          this.setFlowsUrl(result.flowsUrl);
        },
        onError: (result) => {
          this.flowsErrorMessage = result?.[0]?.error || 'Failed to load flows';
          // don't show the reload button for the multiple regions error because reloading won't help
          this.isErrorReloadButtonShown = result?.[0]?.errorCode !== 'flows_multiple_regions';
        },
      });
    },
    getFlowsUrl() {
      return this.$store.getters.getFlowsUrl();
    },
    setFlowsUrl(url) {
      this.$store.commit('setCacheFlowsUrl', url);
    },
    resetFlowsUrl() {
      this.$store.commit('setCacheFlowsUrl', null);
    },
  },
};
</script>
